import { Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from "@/components/ui/command";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { Button } from "@/components/ui/button";
import { Check, ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { useState } from "react";

interface Organization {
  id: number;
  name: string;
}

interface OrganizationSelectorInlineProps {
  organizations: Organization[];
  selectedOrganization: Organization;
  onSelect: (organization: Organization) => void;
  className?: string;
}

export const OrganizationSelectorInline = ({
  organizations,
  selectedOrganization,
  onSelect,
  className
}: OrganizationSelectorInlineProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Collapsible open={open} onOpenChange={setOpen} className={cn("space-y-2", className)}>
      <CollapsibleTrigger asChild>
        <Button
          variant="outline"
          className="w-full justify-between"
        >
          {selectedOrganization.name}
          <ChevronDown className={cn(
            "ml-2 h-4 w-4 shrink-0 transition-transform duration-200",
            open && "rotate-180"
          )} />
        </Button>
      </CollapsibleTrigger>
      <CollapsibleContent>
        <Command className="rounded-lg border">
          <CommandInput placeholder="Search organizations..." />
          <CommandList className="max-h-[200px]">
            <CommandEmpty>No organization found.</CommandEmpty>
            <CommandGroup>
              {organizations.map((organization) => (
                <CommandItem
                  key={organization.id}
                  value={organization.name}
                  onSelect={() => {
                    onSelect(organization);
                    setOpen(false);
                  }}
                >
                  <Check
                    className={cn(
                      "mr-2 h-4 w-4",
                      selectedOrganization.id === organization.id ? "opacity-100" : "opacity-0"
                    )}
                  />
                  {organization.name}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </CollapsibleContent>
    </Collapsible>
  );
};
